import { Button, type ButtonProps } from '@mui/material';
import type { ReactNode } from 'react';
import { SKIN } from '../../../types/enums';
import { createSkinComponent } from '../../../utils/skinComponent';
import NeobetRaisedActionButton from '../../skins/neobet/molecules/NeobetRaisedActionButton';

type ZeroXActionButtonProps = Omit<ButtonProps, 'children'> & {
  label: ReactNode;
};

const DefaultActionButton = ({ label, ...buttonProps }: ZeroXActionButtonProps) => (
  <Button variant='contained' {...buttonProps}>
    {label}
  </Button>
);

const NeobetActionButton = ({ label, ...buttonProps }: ZeroXActionButtonProps) => (
  <NeobetRaisedActionButton label={label} visualVariant='form' {...buttonProps} />
);

const ZeroXActionButton = createSkinComponent(DefaultActionButton, {
  [SKIN.NEOBET]: NeobetActionButton,
});

export default ZeroXActionButton;
